import { adsYellow } from "../utils/ADSColours";

const SpecialDesignationPeriodicity = [
  {
    id: 1,
    gpText: "Everyday",
    osText: undefined,
    colour: adsYellow,
  },
  {
    id: 2,
    gpText: "Working days only",
    osText: undefined,
    colour: adsYellow,
  },
  {
    id: 3,
    gpText: "Weekends",
    osText: undefined,
    colour: adsYellow,
  },
  {
    id: 7,
    gpText: "Monday only",
    osText: undefined,
    colour: adsYellow,
  },
  {
    id: 8,
    gpText: "Tuesday only",
    osText: undefined,
    colour: adsYellow,
  },
  {
    id: 9,
    gpText: "Wednesday only",
    osText: undefined,
    colour: adsYellow,
  },
  {
    id: 10,
    gpText: "Thursday only",
    osText: undefined,
    colour: adsYellow,
  },
  {
    id: 11,
    gpText: "Friday only",
    osText: undefined,
    colour: adsYellow,
  },
  {
    id: 12,
    gpText: "Saturday only",
    osText: undefined,
    colour: adsYellow,
  },
  {
    id: 13,
    gpText: "Sunday only",
    osText: undefined,
    colour: adsYellow,
  },
  {
    id: 14,
    gpText: "Public and Bank Holidays",
    osText: undefined,
    colour: adsYellow,
  },
  {
    id: 15,
    gpText: "Continuous",
    osText: undefined,
    colour: adsYellow,
  },
  {
    id: 16,
    gpText: "Special Arrangements",
    osText: undefined,
    colour: adsYellow,
  },
];

export default SpecialDesignationPeriodicity;
